// extracted by mini-css-extract-plugin
export var link = "_ti-0";